<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import { links, social } from './links.js';
</script>

<!-- eslint-disable better-tailwindcss/no-unknown-classes -->

<footer class="w-full">
	<Section backgroundColor="grey-dark" class="print:hidden">
		{#if links}
			<nav aria-label="Footer" class="mb-16 w-full">
				<ul
					class="
       grid w-full list-none grid-cols-2 justify-between
       md:grid-cols-4
     "
				>
					{#each links as link, i (i)}
						<li
							class={[
								link.order,
								`
          link-section pt-10
          md:pt-0
        `,
							]}
						>
							<a
								class="text-xl! font-bold text-white! no-underline"
								href={link.href}>{link.name}</a
							>
							{#if link.children}
								<ul
									class="
           mt-4 list-none
           md:mt-8
         "
								>
									{#each link.children as child, i (i)}
										<li>
											<a class="text-white! no-underline" href={child.href}
												>{child.name}</a
											>
										</li>
									{/each}
								</ul>
							{/if}
							{#if link.name === 'CONNECT' && social}
								<ul class="social-links row-start-1 list-none flex-row gap-4">
									{#each social as link, i (i)}
										<li>
											<a href={link.href} target="_blank" rel="noreferrer">
												<div class="image">
													<Image
														src={link.img}
														alt={link.name}
														class="max-w-6"
													/>
												</div>
											</a>
										</li>
									{/each}
								</ul>
							{/if}
						</li>
					{/each}
				</ul>
			</nav>
		{/if}

		<div
			class="
     bottom-row grid grid-flow-row gap-4
     md:grid-flow-col md:justify-between
   "
		>
			<div
				class="
      copyright grid grid-flow-row gap-x-8
      md:grid-flow-col
    "
			>
				<p class="mb-0 p-0 text-sm">
					© Indow Windows {new Date().getFullYear()}
				</p>
				<p class="mb-0 p-0 text-sm">Assembled in Portland, OR</p>
				<p class="mb-0 p-0 text-sm">Patent No. US 9976335</p>
			</div>
		</div>
	</Section>
</footer>

<style>
	ul {
		list-style-type: none;
	}

	.copyright p {
		font-weight: 100;
		color: white;
		width: auto;
	}
	.bottom-row {
		display: grid;
		width: 100%;
		align-self: center;
		align-items: flex-end;
	}
	.social-links {
		width: 100%;
		display: flex;
		column-gap: 1rem;
	}
	.social-links a .image {
		width: 100%;
		max-width: 1.5rem;
		height: auto;
	}
</style>
